import { useEffect, useState } from "react";
import type { FC } from "react";
import styles from "./IntervalTimer.module.scss";
import secondsToHms from "@utils/common";

interface IntervalTimerProps {
  onComplete: () => void;
  startingValue: number;
}

/** Countdown timer that displays time in MM:SS format */
const IntervalTimer: FC<IntervalTimerProps> = ({
  onComplete,
  startingValue,
}) => {
  const [timerInSec, setTimerInSec] = useState(startingValue);

  useEffect(() => {
    let timer: ReturnType<typeof setTimeout>;

    if (timerInSec > 0) {
      timer = setTimeout(() => {
        setTimerInSec((val) => val - 1);
      }, 1000);
    } else {
      onComplete();
    }

    return () => clearTimeout(timer);
  }, [timerInSec, onComplete]);

  const { minute, second } = secondsToHms(timerInSec);
  const timeRemaining = `${minute} : ${second}`;

  return (
    <div className={styles["interval-timer"]}>
      <span className={styles["interval-timer__info"]}>Resend code in</span>
      <span className={styles["interval-timer__time"]}>{timeRemaining}</span>
    </div>
  );
};

export default IntervalTimer;
